import { setPageStateById } from '../PageContext';

export const setPage = (setState: setPageStateById) => (sections, widgets) => {
  setState('SET_PAGE', (s) => ({
    ...s,
    sections,
    widgets,
  }));
};
